import { useMsal } from "@azure/msal-react";
import { Button, Chip, Grid, TextField } from "@mui/material";
import { useState } from "react";
import { AlertView } from "./alert";
import { AxiosError } from "axios";
import { getApiAccessToken } from "../auth/auth";
import { createGroups } from "../api/groups";
import { getUserAccess, UserRole } from "../auth/access";

export interface ClientInputProps {
    onAdded: () => void
}

export const ClientInputs: React.FC<ClientInputProps> = (props: ClientInputProps) => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const [errorMessage, setError] = useState<string | null>(null);

    const [clients, setClients] = useState<string[]>([]);
    const [canSubmit, setCanSubmit] = useState<boolean>(true);

    const userRole = getUserAccess(activeAccount)?.role;

    const processInputs = (input: string) => {
        // Split the input based on newlines or commas
        const potentialClients = input.split(/[\n,]/);
        const filtered = potentialClients.filter(client => client != "")

        setClients(filtered)
    }

    const handleSubmitUsers = async (clients: string[]) => {
        try {
            let accessToken: string = await getApiAccessToken(instance, activeAccount)
            await createGroups(accessToken, clients);

            // notify parent to rerender clients
            props.onAdded()
            setClients([])
            setCanSubmit(true)

        } catch (error) {
            if (error instanceof AxiosError) {
                console.log(error)
                setError(error?.message)
            } else if (error instanceof Error) {
                console.error(error);
            }
            setClients([])
            setCanSubmit(true)
        }
    }

    return(
        <Grid container direction="column" sx={{ marginBottom: 5, margin: 2 }}  alignItems="left" justifyContent="left" textAlign="left">
            <AlertView error={errorMessage}/>
            {
                userRole == UserRole.ADMIN ? 
                    <TextField
                        id="outlined-multiline-flexible"
                        label="Create Client"
                        sx={{ maxWidth: 650, marginBottom: 2, marginTop: 1 }}
                        multiline
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            processInputs(event.target.value)
                        }}
                    /> :
                    <></>
            }
            <Grid container direction="row" sx={{ marginBottom: 2 }}>
                {
                    clients.map(client => {
                        return(
                            <Chip
                            key={client}
                            label={client}
                            variant="outlined" 
                            sx={{ maxWidth: 300, flexShrink: 1, margin: 1 }}
                        />
                        )
                    })
                }
            </Grid>
            {
                userRole == UserRole.ADMIN && clients.length > 0 ? 
                    <Button 
                        variant="outlined"
                        disabled={!canSubmit}
                        onClick={() => {
                            handleSubmitUsers(clients)
                            setCanSubmit(false)
                        }}
                        sx={{ maxWidth: 200, marginBottom: 2 }}>
                            Create Client
                    </Button> : 
                    <></>
            }
        </Grid>
    )
}
